import React, { useEffect } from 'react';
import { Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeFilled } from "@ant-design/icons";
import { Space, Button } from "antd";

const PurchaseResult = () => {
  const navigate = useNavigate();
//  useEffect(() => {
//     window.location.reload();
//   }, []); 
   return (

    <div
      style={{
        background: "white",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >

      <Result
        status="success"
        title={
          <span style={{ fontWeight: 700, color: '#0A5587' }}>
            Order Placed Successfully!
          </span>
        }
        subTitle="Order Delivery takes 5-7 days"
        extra={[
          <Space size="large">

            <Button
              type="primary"
              size="large"
              shape="round"
              icon={<HomeFilled />}
              style={{
                padding: "18px 28px",
                fontWeight: "bold",
                backgroundColor: '#0A5587'
              }}
              onClick={() => navigate("/")}
            >
              Home
            </Button>

          </Space>
        ]}
      />

    </div>
  );
};

export default PurchaseResult;